(function () {
    'use strict';

    angular.module("imApp").factory("dataImpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3170,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3171,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
